module.exports = __webpack_public_path__ + "img/emenloading.06b08d50.gif";